export default __webpack_public_path__ + "static/media/jul1.245157c6.jpg";